var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0835 14.5833H11.4755C10.5739 14.5833 9.81988 15.2683 9.73358 16.1658L8.22717 31.8325C8.12833 32.8604 8.93645 33.75 9.96913 33.75H30.0312C31.0639 33.75 31.872 32.8604 31.7732 31.8325L30.2668 16.1658C30.1805 15.2683 29.4264 14.5833 28.5248 14.5833H27.9168V20C27.9168 20.6903 27.3572 21.25 26.6668 21.25C25.9765 21.25 25.4168 20.6903 25.4168 20V14.5833L14.5835 14.5833V20C14.5835 20.6903 14.0239 21.25 13.3335 21.25C12.6431 21.25 12.0835 20.6903 12.0835 20V14.5833ZM14.619 12.0833L25.3814 12.0833C25.0938 9.73516 23.0927 7.91666 20.6668 7.91666H19.3335C16.9076 7.91666 14.9065 9.73516 14.619 12.0833ZM27.8937 12.0833H28.5248C30.7144 12.0833 32.5457 13.747 32.7553 15.9265L34.2617 31.5932C34.5017 34.0896 32.5391 36.25 30.0312 36.25L9.96913 36.25C7.4612 36.25 5.4986 34.0896 5.73865 31.5932L7.24506 15.9265C7.45463 13.747 9.2859 12.0833 11.4755 12.0833H12.1066C12.4037 8.35202 15.5258 5.41666 19.3335 5.41666H20.6668C24.4745 5.41666 27.5966 8.35203 27.8937 12.0833Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.6fa57f3e.svg";
export { ForwardRef as ReactComponent };